module.exports = {
  // eslint-disable-next-line consistent-return
  set() {
    const selected = document.querySelector('ul.pagination-links li.selected');
    let nextHref, prevHref;
    if (selected) {
      let next = selected.nextElementSibling;
      let prev = selected.previousElementSibling;
      next = next && next.querySelector('a');
      prev = prev && prev.querySelector('a');
      nextHref = next && next.href;

      prevHref = prev && prev.href;
    }
    if (nextHref) {
      this.linkNext = this._setLink(nextHref, this.linkNext, 'next');
    } else if (this.linkNext) {
      this.linkNext.remove();
    }

    if (prevHref) {
      this.linkPrev = this._setLink(prevHref, this.linkPrev, 'prev');
    } else if (this.linkPrev) {
      this.linkPrev.remove();
    }
  },

  _setLink(href, oldLink, relValue) {
    const host = `${window.location.protocol}//${window.location.hostname}`;
    const linkNode = document.createElement('link');
    linkNode.href = `${host}${href}`;
    linkNode.rel = relValue;

    if (oldLink && oldLink.parentNode) {
      oldLink.parentNode.removeChild(oldLink);
    }

    document.querySelector('head').appendChild(linkNode);
    return linkNode;
  },
};
